module.exports = __webpack_public_path__ + "static/media/stones_throw.eeb1d6a7.png";